module.exports = __webpack_public_path__ + "img/skipp-contract.bd2d12e9.svg";